import React, { forwardRef, useState } from 'react';
import { SelectionItensDefaultProps } from '../props';
import * as S from '../styles';
export const SingleSelect = forwardRef((props, ref) => {
  const {
    SelectionItens = SelectionItensDefaultProps.SelectionItens,
    onSelectedChange,
    defaultSelectedItemIndex
  } = props;
  const [checked] = useState(new Array(SelectionItens === null || SelectionItens === void 0 ? void 0 : SelectionItens.length).fill(false));
  const [selectedItemIndex, setSelectedItemIndex] = useState(defaultSelectedItemIndex !== undefined ? defaultSelectedItemIndex : null);
  const handleOnChange = index => {
    if (index === selectedItemIndex) {
      setSelectedItemIndex(null);
      onSelectedChange && onSelectedChange([]);
    } else {
      setSelectedItemIndex(index);
      onSelectedChange && onSelectedChange([SelectionItens[index].value]);
    }
  };
  return React.createElement(S.ListU, null, SelectionItens === null || SelectionItens === void 0 ? void 0 : SelectionItens.map((_ref, index) => {
    let {
      value,
      icon,
      isDisabled
    } = _ref;
    return React.createElement(S.ListI, {
      key: index
    }, React.createElement(S.InputWrapper, {
      ref: ref
    }, React.createElement(S.Input, {
      "data-ds-component": "DS-Chips",
      "data-testid": "single-chips-input-".concat(index),
      type: "radio",
      className: "".concat(checked[index] ? 'checked-chips' : 'not-checked-chips', " hide-element"),
      id: "single-chips-id-".concat(index),
      name: value,
      checked: index === selectedItemIndex,
      "aria-checked": index === selectedItemIndex,
      disabled: isDisabled,
      "aria-disabled": isDisabled,
      tabIndex: 0,
      onChange: () => handleOnChange(index)
    }), React.createElement("label", {
      htmlFor: "single-chips-id-".concat(index),
      className: (value === null || value === void 0 ? void 0 : value.length) === 1 ? 'oneValue' : ''
    }, icon, value)));
  }));
});
SingleSelect.displayName = 'SingleSelect';